import { DataServiceEntities } from './dataService/entities';

class DataServiceClass extends DataServiceEntities {}

export const DataService = new DataServiceClass();
